module.exports = __webpack_public_path__ + "img/baogao1.de1fee8c.png";